//   document.addEventListener('DOMContentLoaded', () => {
//     const selectElement = document.getElementById('colorSelector');
//     if (!selectElement) return;

//     // change redirect
//     selectElement.addEventListener('change', function() {
//       window.location.href = this.value;
//     });

//     const options = selectElement.options;

//     if (options.length === 1) {
//       selectElement.disabled = true;
//       selectElement.closest('.select')?.style && (selectElement.closest('.select').style.pointerEvents = 'none');
//       selectElement.closest('.select')?.querySelector('svg')?.style && (selectElement.closest('.select').querySelector('svg').style.display = 'none');
//     }

//     for (let i = 0; i < options.length; i++) {
//       options[i].classList.remove('hidden');
//     }

//     const selectedOption = selectElement.options[selectElement.selectedIndex];
//     selectedOption?.classList.add('hidden');
//   });

//   document.addEventListener('DOMContentLoaded', () => {
//     const variantSelects = document.querySelectorAll('variant-selects');

//  function applyOptionValue(select, value) {
//       const variantSelectsEl = select.closest('variant-selects');
//       if (!variantSelectsEl) return;

//       const optionName = select.dataset.optionName;
//       const realSelect = variantSelectsEl.querySelector(`select[name="options[${optionName}]"]`);

//       console.log('%c[DEBUG] applyOptionValue → Talla seleccionada', 'color: #00ff00; font-weight: bold', { value, optionName });

//       if (!realSelect) return;

//       realSelect.value = value;
//       realSelect.dispatchEvent(new Event('change', { bubbles: true }));

//       const textEl = select.querySelector('.selected-text');
//       if (textEl) textEl.textContent = value;

//       updateAddToCartState(variantSelectsEl);
//     }
    
//     function updateAddToCartState(variantSelects) {
//       const formId = variantSelects.dataset.formId;
//       if (!formId) return;

//       // Solo tocamos el botón mobile
//       let button = document.querySelector('.btn-add-to-cart[name="add"]');
//       if (!button) return;

//       console.log('%c[DEBUG] updateAddToCartState → modificando botón mobile', 'color: orange', button.id);

//       const customSelects = variantSelects.querySelectorAll('.custom-select');
//       const allSelected = [...customSelects].every(cs => {
//         const textEl = cs.querySelector('.selected-text');
//         const text = textEl ? textEl.textContent.trim() : '';
//         return text !== '' && text !== 'Selecciona una talla';
//       });

//       if (allSelected) {
//         button.setAttribute('form', formId);
//         console.log('%c[DEBUG] ✅ Botón mobile ahora tiene form correcto', 'color: #00ff00', formId);
//       } else {
//         button.setAttribute('form', '#');
//         console.log('%c[DEBUG] ❌ Botón mobile mantiene form="#"', 'color: red');
//       }
//     }

//     // ====================== INIT ======================
//     // Solo forzamos el texto visible del custom-select (no tocamos los select reales)
//     document.querySelectorAll('.custom-select .selected-text').forEach(el => {
//       el.textContent = 'Selecciona una talla';
//     });

//     // Actualizamos solo el estado del botón mobile (sin romper el desktop)
//     variantSelects.forEach(vs => {
//       updateAddToCartState(vs);
//     });

//     // Click en botón "Agregar al carrito" → SOLO el botón mobile abre drawer
//     document.addEventListener('click', function(e) {
//       const btn = e.target.closest('.btn-add-to-cart');
//       if (!btn) return;   // ← ignora completamente el botón de escritorio

//       const formId = btn.getAttribute('form');
//       console.log('%c[DEBUG] Click en botón mobile', 'color: #ffff00', { formIdActual: formId });

//       if (!formId || formId === '#') {
//         e.preventDefault();
//         console.log('%c[DEBUG] → Abriendo drawer', 'color: red');
//         const firstSelect = document.querySelector('.custom-select');
//         if (firstSelect) {
//           const drawer = firstSelect.querySelector('.select-drawer');
//           if (drawer) openMobileDrawer(drawer);
//         }
//         return;
//       }
//       console.log('%c[DEBUG] → Agregando al carrito', 'color: #00ff00');
//     });

//     // HELPERS
//     function closeAllSelectsExcept(current, mode = 'desktop') {
//       document.querySelectorAll('.custom-select').forEach(select => {
//         if (select !== current) {
//           select.classList.remove('open');
//           if (mode === 'desktop') {
//             select.querySelector('.select__dropdown')?.classList.remove('open');
//           }
//           if (mode === 'mobile') {
//             select.querySelector('.select-drawer')?.classList.remove('open');
//           }
//         }
//       });
//       if (mode !== 'mobile') {
//         closeMobileDrawer(true);
//       }
//     }

//     let drawerIsOpen = false;
//     let ignoreCloseUntil = 0;

//     function openMobileDrawer(drawer) {
//       if (drawerIsOpen) return;
//       drawerIsOpen = true;
//       drawer.classList.add('open');
//       document.body.classList.add('drawer-open');
//       if (drawerOverlay) drawerOverlay.classList.add('active');

//       document.body.style.overflow = 'hidden';
//       document.documentElement.style.overflow = 'hidden';

//       ignoreCloseUntil = Date.now() + 500;
//     }

//     function closeMobileDrawer(force = false) {
//       if (!drawerIsOpen) return;
//       if (!force && Date.now() < ignoreCloseUntil) {
//         return;
//       }
//       drawerIsOpen = false;
//       document.querySelectorAll('.select-drawer.open').forEach(d => d.classList.remove('open'));
//       document.querySelectorAll('.custom-select.open').forEach(s => s.classList.remove('open'));
//       document.body.classList.remove('drawer-open');
//       if (drawerOverlay) drawerOverlay.classList.remove('active');

//       document.body.style.overflow = '';
//       document.documentElement.style.overflow = '';
//     }

//     let drawerOverlay = document.querySelector('.drawer-overlay');
//     if (!drawerOverlay) {
//       drawerOverlay = document.createElement('div');
//       drawerOverlay.className = 'drawer-overlay';
//       document.body.appendChild(drawerOverlay);
//       drawerOverlay.addEventListener('click', () => {
//         closeMobileDrawer(true);
//       });
//     }

//     // Abre selector
//     function openSelector(e, select, dropdown, drawer) {
//       e.preventDefault();
//       e.stopPropagation();

//       const isCurrentlyMobile = window.matchMedia('(max-width: 767px)').matches;

//       const isOpen = select.classList.contains('open');

//       // 🔥 DESKTOP toggle
//       if (!isCurrentlyMobile && isOpen) {
//         select.classList.remove('open');
//         dropdown?.classList.remove('open');
//         return;
//       }

//       closeAllSelectsExcept(select, isCurrentlyMobile ? 'mobile' : 'desktop');

//       select.classList.add('open');

//       if (isCurrentlyMobile && drawer) {
//         openMobileDrawer(drawer);
//       } else if (dropdown) {
//         dropdown.classList.add('open');
//       }
//     }

//     document.querySelectorAll('.custom-select').forEach(select => {
//       const selected = select.querySelector('.select__selected');
//       const dropdown = select.querySelector('.select__dropdown');
//       const drawer   = select.querySelector('.select-drawer');

//       const closeBtn = select.querySelector('.drawer-close-btn');

//       closeBtn?.addEventListener('click', e => {
//         e.preventDefault();
//         e.stopPropagation();
//         closeMobileDrawer(true);
//       });

//       if (!selected) return;

//       // ←←← CAMBIO AQUÍ ←←←
//       selected.addEventListener('click', e => {
//         openSelector(e, select, dropdown, drawer);
//       });
//       // ←←← FIN DEL CAMBIO ←←←

//       // OPCIONES DESKTOP (sin cambios)
//       dropdown?.querySelectorAll('.select__option').forEach(option => {
//         option.addEventListener('click', e => {
//           if (option.dataset.action === 'find-size' || option.classList.contains('disabled')) {
//             return; // ← permite que llegue al listener de la guía
//           }
//           e.stopPropagation();
//           const value = option.dataset.value;
//           if (!value) return;
//           applyOptionValue(select, value);
//           select.classList.remove('open');
//           dropdown.classList.remove('open');
//         });
//       });

//       // OPCIONES MOBILE (DRAWER) (sin cambios)
//       drawer?.querySelectorAll('.select__option').forEach(option => {
//         option.addEventListener('click', e => {
//           if (option.dataset.action === 'find-size' || option.classList.contains('disabled')) {
//             return;
//           }
//           e.stopPropagation();
//           const value = option.dataset.value;
//           if (!value) return;
//           applyOptionValue(select, value);
//           closeMobileDrawer(true);
//         });
//       });
//     });

    

//     // CLIC FUERA
//     document.addEventListener('click', e => {
//       const isCurrentlyMobile = window.matchMedia('(max-width: 767px)').matches;

//       if (isCurrentlyMobile && document.body.classList.contains('drawer-open')) {
//         const openDrawer = document.querySelector('.select-drawer.open');
//         if (openDrawer && !openDrawer.contains(e.target) && !e.target.closest('.select__selected')) {
//           closeMobileDrawer();
//         } else {
//         }
//         return;
//       }

//       if (!isCurrentlyMobile) {
//       const clickedInside = [...document.querySelectorAll('.custom-select.open')]
//         .some(sel => sel.contains(e.target));
//       if (!clickedInside) {
//         closeAllSelectsExcept(null, 'desktop');
//       }
//       }
//     });

//     // SINCRONIZACIÓN EXTERNA
//     document.addEventListener('change', e => {
//       const target = e.target;
//       if (target.tagName !== 'SELECT' || !target.name?.startsWith('options[')) return;

//       const optionName = target.name.replace('options[', '').replace(']', '');
//       const value = target.value;

//       const customSelect = document.querySelector(`.custom-select[data-option-name="${optionName}"]`);
//       if (customSelect) {
//         const text = customSelect.querySelector('.selected-text');
//         if (text) text.textContent = value || 'Selecciona una talla';
//       }
//     });
//   });

// document.addEventListener('click', function(e) {
//   const btn = e.target.closest('.select__option[data-action="find-size"]');
//   if (!btn) return;

//   e.preventDefault();

//   openSizeGuide(); // 🔥 directo
// });

// function openSizeGuide() {
//   const btn =
//     document.querySelector('#btn-guia-talla-with-metaobject') ||
//     document.querySelector('#btn-guia-tallas-2');

//   if (btn) {
//     btn.click();
//   } else {
//     console.log('❌ No se encontró botón de guía de tallas');
//   }
// }
document.addEventListener('DOMContentLoaded', () => {
    if (window.__variantPickerInitialized) return;
    window.__variantPickerInitialized = true;

    const variantSelects = document.querySelectorAll('variant-selects');

    function applyOptionValue(select, value, option) {
      const variantSelectsEl = select.closest('variant-selects');
      if (!variantSelectsEl) return;

      const optionName = select.dataset.optionName;
      const realSelect = variantSelectsEl.querySelector(
        `select[name="options[${optionName}]"]`
      );

      if (!realSelect) return;

      // 1. Actualizar el select oculto
      realSelect.value = value;

      // 2. Actualizar texto visual inmediatamente (feedback al usuario)
      const textEl = select.querySelector('.selected-text');
      if (textEl) textEl.textContent = value;

      // 2b. Marcar visualmente la opción elegida (versión escritorio y drawer
      //     móvil) de forma síncrona, sin depender del script de
      //     product-variant-options.liquid (que lo hace vía
      //     requestAnimationFrame y llega tarde).
      if (option) {
        const optionPosition = option.dataset.optionPosition;
        variantSelectsEl
          .querySelectorAll(`.select__option[data-option-position="${optionPosition}"]`)
          .forEach(btn => {
            btn.classList.toggle('is-selected', btn.dataset.value === value);
          });
      }

      // 3. Disparar el evento "change" REAL sobre el select oculto para que
      //    Shopify (VariantSelects.onVariantChange, definida en global.js)
      //    ejecute su flujo nativo completo:
      //      - recalcular currentVariant (updateOptions + updateMasterId)
      //      - actualizar el input oculto name="id" de TODOS los formularios
      //        del producto (updateVariantInput) — incluye nuestro
      //        #product-variant-id-checkout
      //      - refrescar precio/SKU/disponibilidad (renderProductInfo)
      //      - republicar PUB_SUB_EVENTS.variantChange, que es lo que hace
      //        que product-info.js recalcule los límites de cantidad/stock
      //        (data-cart-quantity, min, max) de la variante recién elegida
      //      - habilitar/deshabilitar el botón "Agregar al carrito" según la
      //        disponibilidad real de esa variante
      //      - actualizar la URL con ?variant=
      //
      //    Antes solo llamábamos updateOptions()/updateMasterId() a mano y
      //    parcheábamos el input de variante por nuestra cuenta, sin pasar
      //    por ese flujo. Por eso, justo después de agregar una talla al
      //    carrito (que sí dispara el refresco de stock, pero para la talla
      //    que estaba activa en ese momento), al cambiar a otra talla el
      //    formulario se quedaba con los límites de stock de la talla
      //    anterior y mostraba "sin stock" hasta recargar la página.
      realSelect.dispatchEvent(new Event('change', { bubbles: true }));

      if (!variantSelectsEl.currentVariant) {
        // Variante no disponible — solo actualizar estado del botón
        updateAddToCartState(variantSelectsEl);
      }
    }
    
    function updateAddToCartState(variantSelects) {
      const formId = variantSelects.dataset.formId;
      if (!formId) return;

      let button = document.querySelector('.btn-add-to-cart[name="add"]');
      
      if (!button) return;

      console.log('%c[DEBUG] updateAddToCartState → modificando botón mobile', 'color: orange', button.id);

      const customSelects = variantSelects.querySelectorAll('.custom-select');
      const allSelected = [...customSelects].every(cs => {
        const textEl = cs.querySelector('.selected-text');
        const text = textEl ? textEl.textContent.trim() : '';
        return text !== '' && text !== 'Selecciona una talla';
      });

      if (allSelected) {
        button.setAttribute('form', formId);
        console.log('%c[DEBUG] ✅ Botón mobile ahora tiene form correcto', 'color: #00ff00', formId);
      } else {
        button.setAttribute('form', '#');
        console.log('%c[DEBUG] ❌ Botón mobile mantiene form="#"', 'color: red');
      }
    }

    // ====================== INIT ======================
    document.querySelectorAll('.custom-select .selected-text').forEach(el => {
      el.textContent = 'Selecciona una talla';
    });

    // ✅ FIX FLASH: marca como listo DESPUÉS de setear el texto
    document.querySelectorAll('.custom-select').forEach(cs => {
      cs.classList.add('js-ready');
    });

    variantSelects.forEach(vs => {
      updateAddToCartState(vs);
    });

    // Click en botón "Agregar al carrito" → SOLO el botón mobile abre drawer
    document.addEventListener('click', function(e) {
      const btn = e.target.closest('.btn-add-to-cart');
      if (!btn) return;

      const formId = btn.getAttribute('form');
      console.log('%c[DEBUG] Click en botón mobile', 'color: #ffff00', { formIdActual: formId });

        if (formId === '#') {
        e.preventDefault();
        console.log('%c[DEBUG] → Abriendo drawer', 'color: red');
        const firstSelect = document.querySelector('.custom-select');
        if (firstSelect) {
          const drawer = firstSelect.querySelector('.select-drawer');
          if (drawer) openMobileDrawer(drawer);
        }
        return;
      }
      console.log('%c[DEBUG] → Agregando al carrito', 'color: #00ff00');
    });

    // HELPERS
    function closeAllSelectsExcept(current, mode = 'desktop') {
      document.querySelectorAll('.custom-select').forEach(select => {
        if (select !== current) {
          select.classList.remove('open');
          if (mode === 'desktop') {
            select.querySelector('.select__dropdown')?.classList.remove('open');
          }
          if (mode === 'mobile') {
            select.querySelector('.select-drawer')?.classList.remove('open');
          }
        }
      });
      if (mode !== 'mobile') {
        closeMobileDrawer(true);
      }
    }

    let drawerIsOpen = false;
    let ignoreCloseUntil = 0;

    function openMobileDrawer(drawer) {
      if (drawerIsOpen) return;
      drawerIsOpen = true;
      drawer.classList.add('open');
      document.body.classList.add('drawer-open');
      if (drawerOverlay) drawerOverlay.classList.add('active');

      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';

      ignoreCloseUntil = Date.now() + 500;
    }

    function closeMobileDrawer(force = false) {
      if (!drawerIsOpen) return;
      if (!force && Date.now() < ignoreCloseUntil) return;

      drawerIsOpen = false;
      document.querySelectorAll('.select-drawer.open').forEach(d => d.classList.remove('open'));
      document.querySelectorAll('.custom-select.open').forEach(s => s.classList.remove('open'));
      document.body.classList.remove('drawer-open');
      if (drawerOverlay) drawerOverlay.classList.remove('active');

      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
    }

    let drawerOverlay = document.querySelector('.drawer-overlay');
    if (!drawerOverlay) {
      drawerOverlay = document.createElement('div');
      drawerOverlay.className = 'drawer-overlay';
      document.body.appendChild(drawerOverlay);
      drawerOverlay.addEventListener('click', () => {
        closeMobileDrawer(true);
      });
    }

    // Abre selector
    function openSelector(e, select, dropdown, drawer) {
      e.preventDefault();
      e.stopPropagation();

      const isCurrentlyMobile = window.matchMedia('(max-width: 767px)').matches;
      const isOpen = select.classList.contains('open');

      if (!isCurrentlyMobile && isOpen) {
        select.classList.remove('open');
        dropdown?.classList.remove('open');
        return;
      }

      closeAllSelectsExcept(select, isCurrentlyMobile ? 'mobile' : 'desktop');

      select.classList.add('open');

      if (isCurrentlyMobile && drawer) {
        openMobileDrawer(drawer);
      } else if (dropdown) {
        dropdown.classList.add('open');
      }
    }

    document.querySelectorAll('.custom-select').forEach(select => {
      const selected = select.querySelector('.select__selected');
      const dropdown = select.querySelector('.select__dropdown');
      const drawer   = select.querySelector('.select-drawer');
      const closeBtn = select.querySelector('.drawer-close-btn');

      closeBtn?.addEventListener('click', e => {
        e.preventDefault();
        e.stopPropagation();
        closeMobileDrawer(true);
      });

      if (!selected) return;

      selected.addEventListener('click', e => {
        openSelector(e, select, dropdown, drawer);
      });

      // OPCIONES DESKTOP
      dropdown?.querySelectorAll('.select__option').forEach(option => {
        option.addEventListener('click', e => {
          if (option.dataset.action === 'find-size' || option.classList.contains('disabled')) return;
          e.stopPropagation();
          const value = option.dataset.value;
          if (!value) return;
          applyOptionValue(select, value, option);
          select.classList.remove('open');
          dropdown.classList.remove('open');
        });
      });

      // OPCIONES MOBILE (DRAWER)
      drawer?.querySelectorAll('.select__option').forEach(option => {
        option.addEventListener('click', e => {
          if (option.dataset.action === 'find-size' || option.classList.contains('disabled')) return;
          e.stopPropagation();
          const value = option.dataset.value;
          if (!value) return;
          applyOptionValue(select, value, option);
          closeMobileDrawer(true);
        });
      });
    });

    // CLIC FUERA
    document.addEventListener('click', e => {
      const isCurrentlyMobile = window.matchMedia('(max-width: 767px)').matches;

      if (isCurrentlyMobile && document.body.classList.contains('drawer-open')) {
        const openDrawer = document.querySelector('.select-drawer.open');
        if (openDrawer && !openDrawer.contains(e.target) && !e.target.closest('.select__selected')) {
          closeMobileDrawer();
        }
        return;
      }

      if (!isCurrentlyMobile) {
        const clickedInside = [...document.querySelectorAll('.custom-select')]
          .some(sel => sel.contains(e.target));
        if (!clickedInside) {
          closeAllSelectsExcept(null, 'desktop');
        }
      }
    });

    // SINCRONIZACIÓN EXTERNA
    document.addEventListener('change', e => {
      const target = e.target;
      if (target.tagName !== 'SELECT' || !target.name?.startsWith('options[')) return;

      const optionName = target.name.replace('options[', '').replace(']', '');
      const value = target.value;

      const customSelect = document.querySelector(`.custom-select[data-option-name="${optionName}"]`);
      if (customSelect) {
        const text = customSelect.querySelector('.selected-text');
        if (text) text.textContent = value || 'Selecciona una talla';
      }
    });
  });

// ====================== GUÍA DE TALLAS ======================
document.addEventListener('click', function(e) {
  const btn = e.target.closest('.select__option[data-action="find-size"]');
  if (!btn) return;

  e.preventDefault();
  openSizeGuide();
});

function openSizeGuide() {
  const btn =
    document.querySelector('#btn-guia-talla-with-metaobject') ||
    document.querySelector('#btn-guia-tallas-2');

  if (btn) {
    btn.click();
  } else {
    console.log('❌ No se encontró botón de guía de tallas');
  }
}